<template>
  <base-modal
    ref="modal"
    :title="title"
    :loading="isSaving"
    @show="toggleModal"
    @hidden="resetModal"
    @ok="handleOk"
    ok-title="Save"
    cancel-title="Cancel"
    cancel-variant="light"
    footer-class="justify-between"
  >
    <form ref="form" @submit.stop.prevent="handleSubmit">
      <div class="mb-4"><label for="title" class="block text-[13px] font-medium text-ink mb-1.5">Title</label>
        <input
          id="title"
          v-model="body.title"
          required
          placeholder=""
          class="w-full border border-border-hover rounded-[10px] px-3.5 py-2.5 text-sm font-[inherit] leading-normal transition-[border-color] duration-150 focus:border-primary focus:ring-3 focus:ring-primary/10 outline-none"
        >
      </div>

      <div class="mb-4"><label for="description" class="block text-[13px] font-medium text-ink mb-1.5">Description</label>
        <textarea
          id="description"
          v-model="body.description"
          placeholder=""
          rows="2"
          max-rows="4"
          class="w-full border border-border-hover rounded-[10px] px-3.5 py-2.5 text-sm font-[inherit] leading-normal transition-[border-color] duration-150 focus:border-primary focus:ring-3 focus:ring-primary/10 outline-none">
        </textarea>
      </div>

      <div class="mb-4"><label for="shortDescription" class="block text-[13px] font-medium text-ink mb-1.5">Short description</label>
        <textarea
          id="shortDescription"
          v-model="body.shortDescription"
          placeholder=""
          rows="2"
          max-rows="4"
          class="w-full border border-border-hover rounded-[10px] px-3.5 py-2.5 text-sm font-[inherit] leading-normal transition-[border-color] duration-150 focus:border-primary focus:ring-3 focus:ring-primary/10 outline-none">
        </textarea>
      </div>

      <div class="mb-4"><label for="logo" class="block text-[13px] font-medium text-ink mb-1.5">Logo</label>
        <input
          id="logo"
          v-model="body.logo"
          required
          placeholder=""
          class="w-full border border-border-hover rounded-[10px] px-3.5 py-2.5 text-sm font-[inherit] leading-normal transition-[border-color] duration-150 focus:border-primary focus:ring-3 focus:ring-primary/10 outline-none"
        >
      </div>

      <div class="mb-4"><label for="status" class="block text-[13px] font-medium text-ink mb-1.5">Status</label>
        <base-select v-model="body.isActive" :options="statusOptions" value-key="value" label-key="text" placeholder="Select status"></base-select>
      </div>

      <div class="mb-4"><label for="status" class="block text-[13px] font-medium text-ink mb-1.5">Payment</label>
        <base-select v-model="body.isFree" :options="bodyPaymentOptions" value-key="value" label-key="text" placeholder="Select payment"></base-select>
      </div>
    </form>
  </base-modal>
</template>

<script>
import { mapState } from 'vuex'
import dayjs from 'dayjs'
import { slugify } from '@/services/utils'
import BaseSelect from '../../UIComponents/BaseSelect'

export default {
  components: { BaseSelect },
  props: {
    item: [Object]
  },
  data () {
    return {
      isSaving: false,
      body: {
        title: '',
        slug: '',
        createdAt: '',
        isActive: true,
        isFree: false,
        description: '',
        shortDescription: '',
        logo: ''
      }
    }
  },
  computed: {
    ...mapState({
      statusOptions: state => state.auth.statusOptions,
      bodyPaymentOptions: state => state.auth.bodyPaymentOptions,
      bodyTypeOptions: state => state.auth.bodyTypeOptions
    }),
    slug () {
      return slugify(this.body.title)
    },
    title () {
      if (this.item) {
        return 'Edit endorsement body'
      } else {
        return 'Add endorsement body'
      }
    }
  },
  methods: {
    checkFormValidity () {
      const valid = this.$refs.form.checkValidity()
      this.nameState = valid ? 'valid' : 'invalid'
      return valid
    },
    handleSubmit () {
      this.isSaving = true
      const { body } = this
      if (this.item) {
        this.$store.dispatch('UPDATE_BODY', body).then((response) => {
          this.isSaving = false
          this.$emit('update')
          this.$nextTick(() => {
            this.$refs.modal.hide()
          })
        }).catch(() => { this.isSaving = false })
      } else {
        this.body.slug = this.slug
        this.body.createdAt = dayjs().format()
        this.$store.dispatch('CREATE_BODY', { body }).then((response) => {
          this.isSaving = false
          this.$emit('update')
          this.$nextTick(() => {
            this.$refs.modal.hide()
          })
        }).catch(() => { this.isSaving = false })
      }
    },
    resetModal () {
      this.body.title = ''
      this.body.createdAt = ''
      this.body.slug = ''
      this.body.isActive = true
      this.body.isFree = false
      this.body.description = ''
      this.body.shortDescription = ''
      this.body.logo = ''
    },
    showModal () {
      this.$refs['modal'].show()
    },
    hideModal () {
      this.$refs['modal'].hide()
    },
    toggleModal () {
      this.resetModal()
      if (this.item) {
        this.body.title = this.item.title ? this.item.title : ''
        this.body.createdAt = this.item.createdAt ? this.item.createdAt : ''
        this.body.isActive = this.item.isActive ? this.item.isActive : true
        this.body.isFree = this.item.isFree ? this.item.isFree : false
        this.body.slug = this.item.slug ? this.item.slug : ''
        this.body.description = this.item.description ? this.item.description : ''
        this.body.shortDescription = this.item.shortDescription ? this.item.shortDescription : ''
        this.body.logo = this.item.logo ? this.item.logo : ''
      }
    },
    handleOk (bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.handleSubmit()
    }
  }
}
</script>